import React from 'react'
import { cn } from '@scalis/utils'
import { IconProps } from './icon.types'

/**
 * @deprecated Use `Icon` from `@scalis/components` instead.
 */
export const Icon: React.FC<IconProps> = ({ icon, size, className, ...props }) => {
  return (
    <i
      aria-hidden
      className={cn(icon, className, size ? `text-[${size}px]` : '')}
      {...props}
    />
  )
}
